// SearchResultsModal.tsx - full-screen modal for global search results
// (mirrors trade). Hosts the GlobalSearchFilterComponent multifilter.

import { useState, useEffect } from 'react';
import {
  Dialog,
  DialogContent,
  IconButton,
  Box,
  Typography,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import GlobalSearchFilterComponent from './GlobalSearchFilterComponent';

interface SearchResultsModalProps {
  open: boolean;
  onClose: () => void;
  searchQuery: string;
  initialFilters?: {
    ranges?: string[];
    designs?: string[];
    colours?: string[];
    brands?: string[];
    applications?: string[];
    design_styles?: string[];
  };
}

function SearchResultsModal({
                              open,
                              onClose,
                              searchQuery,
                              initialFilters,
                            }: SearchResultsModalProps) {
  const [currentSearchQuery, setCurrentSearchQuery] = useState(searchQuery);

  useEffect(() => {
    if (open) {
      setCurrentSearchQuery(searchQuery);
    }
  }, [open, searchQuery]);

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth={false}
      fullWidth
      PaperProps={{
        sx: {
          width: '90vw',
          height: '90vh',
          maxWidth: '90vw',
          maxHeight: '90vh',
          margin: '5vh',
          borderRadius: '12px',
          overflow: 'hidden',
        },
      }}
    >
      {/* Header with close button */}
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          padding: '16px 24px',
          borderBottom: '1px solid #e0e0e0',
          backgroundColor: '#fafafa',
        }}
      >
        <Box>
          <Typography
            variant="h5"
            sx={{
              fontWeight: 600,
              color: '#333',
            }}
          >
            Search Results
          </Typography>
          {currentSearchQuery && (
            <Typography
              variant="body2"
              sx={{
                color: '#666',
                mt: 0.5,
              }}
            >
              Showing results for: <strong>"{currentSearchQuery}"</strong>
            </Typography>
          )}
        </Box>

        <IconButton
          onClick={onClose}
          sx={{
            color: '#666',
            '&:hover': {
              backgroundColor: '#e0e0e0',
            },
          }}
        >
          <CloseIcon />
        </IconButton>
      </Box>

      {/* Content */}
      <DialogContent
        sx={{
          padding: 0,
          overflow: 'hidden',
          height: 'calc(100% - 73px)',
        }}
      >
        <GlobalSearchFilterComponent
          initialSearchQuery={searchQuery}
          initialFilters={initialFilters}
          onClose={onClose}
          onSearchQueryChange={setCurrentSearchQuery}
        />
      </DialogContent>
    </Dialog>
  );
}

export default SearchResultsModal;
